import { render, staticRenderFns } from "./TableAddQuotesForOc.vue?vue&type=template&id=d995a89a"
import script from "./TableAddQuotesForOc.vue?vue&type=script&lang=js"
export * from "./TableAddQuotesForOc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports